import * as React from 'react';
import { Container, Row, Col } from "reactstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {  faLanguage} from '@fortawesome/free-solid-svg-icons';
import { stat } from 'fs';
import 'react-notifications-component/dist/theme.css';

import LanguageList from "./languageList";
import LanguageDetail from "./languageDetail";
import { Capitalize, showAlert } from '../common/functions';

class LanguagePageComponent extends React.Component {
  state = {
    isView: false,
    page: "",
    languageCode: "",
    title: ""
  }

  constructor(props: any) {
    super(props);
    this.state = {
      isView: false,
      page: "",
      languageCode: "",
      title: ""
    }
	  this.handleCallBackMethod = this.handleCallBackMethod.bind(this);
  }

  componentDidMount() {
    var tokenstr = (new URLSearchParams(window.location.search)).get("page");
    let tValue = tokenstr === null ? "" : tokenstr
    var idstr = (new URLSearchParams(window.location.search)).get("id");
    var id = idstr === null ? "" : idstr;
    var pageValue = id === "" ? tValue : "detail";
    this.setState({
      ...stat,
      page: pageValue,
      languageCode: id,
      isView: pageValue === "" ? true : false
    });

    var alertMessage = window.localStorage.getItem('alertMessage');
    if (alertMessage && alertMessage !== "") {
			showAlert(alertMessage, false);
      window.localStorage.setItem('alertMessage', "");
	  }

	  document.title = `${ pageValue==="" ? "Languages" : "Language"} - Daily Audio Bible Administration`;
  }

  handleCallBackMethod(value) {
    this.setState({ title: value });
  }

  render() {
    return (
    <Container>
      <Row>            
        <Col lg="12">
            {this.state.page === "add" && (
              <div>               
                <h2>
                    <FontAwesomeIcon icon={faLanguage} />
					<span data-testid="languagePageTitle"> Languages - Create New</span>
                </h2>
                <hr />
				<LanguageDetail callback={this.handleCallBackMethod} languageCode={this.state.languageCode} />
              </div>
            )}
            {this.state.page === "detail" && (
              <div>
                <h2>
                  <FontAwesomeIcon icon={faLanguage} />
                  <span data-testid="languagePageTitle"> Languages - {Capitalize(this.state.title)} Details</span>
				</h2>
				<hr />
				<LanguageDetail callback={this.handleCallBackMethod} languageCode ={ this.state.languageCode}/>
              </div>
            )}
            {this.state.page === "" && this.state.isView && (
              <div>
                <h2>
                  <FontAwesomeIcon icon={faLanguage} />
                  <span data-testid="languagePageTitle"> Languages</span>
                </h2>
                <hr />
				<LanguageList />
          </div>)}
        </Col>
      </Row>
    </Container>
    );
  }
}

export default LanguagePageComponent;
